// Module
var code = "<template> <section class=\"care-plan-view\"> <require from=\"app/cm/components/case/care-plan/care-plan\" as=\"careplan-view\"></require> <careplan-view case-id.bind=\"caseId\" readonly.bind=\"readonly\"></careplan-view> </section> </template> ";
// Exports
module.exports = code;